<script setup lang="ts">
const props = withDefaults(defineProps<{
  parent: boolean
  active: boolean
  label: string
  slug: string
  name: string
}>(), { parent: false, label: '', active: false, slug: '' })

const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const route = useRoute()

const open = ref(false)

function toggleSubMenu() {
  open.value = !open.value
}
function processAction() {
  if (props.parent)
    toggleSubMenu()

  else
    emit('toggle')
}

</script>

<template>
  <!-- Default content when no slot is provided -->
  <div class="flyout-menu-item" :class="{ 'is-parent': parent, 'open': open, active }">

    <template v-if="$slots.default">
      <button class="label" @click="processAction">
        {{ label }}
      </button>

      <!-- <transition-slide :offset="[0, -100]" mode="out-in" appear> -->
      <div v-if="open" key="flyout-child" class="sec-sub-items">
        <slot />  
      </div>

      <div class="sub-arrow" :class="{ active }" @click="toggleSubMenu">
        <i class="i-mdi:chevron-right" />
      </div>
      <!-- </transition-slide> -->
    </template>

    <template v-else>
      <button class="label" @click="processAction">
        {{ label }}
      </button>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.flyout-menu-item {
  width: 100%;
  display: flex;
  align-items: center;

  position: relative;

  flex-direction: column;

  * {
    font-size: 14px;
  }

  button {
    width: 100%;

    padding: 1rem;
    border-bottom: 1px solid gainsboro;

    &:hover {
      background: var(--base-100);
      transform: translateY(-1px);
      &:active {
        transform: translateY(0);
      }
    }

    &:focus {
      outline: 0;
    }
  }
  .sec-sub-items {
    width: 100%;
  }

  &.is-parent {
    > .sub-arrow {
      position: absolute;
      right: 0;
      top: 23px;
      transform: translate(0, -50%);
      width: gr(1);
      height: gr(1);
      display: flex;
      align-items: center;

      > i {
        display: inline-block;
        font-size: fs(0);

        color: var(--base-500);

        transition: all 0.15s ease;
      }
    }

    &.active {
      > .sub-arrow {
        > i {
          transform: rotate(90deg);
        }
      }
    }
  }

  &.open {
    &.is-parent {
      > .sub-arrow {
        > i {
          transform: rotate(90deg);
        }
      }
    }
  }

  &.active {
    > .label {
      color: var(--primary);
      font-weight: bold;
    }
  }
}
</style>
